import React from 'react'
import styled from 'react-emotion'
import { FONT_SMALL } from '../constants'
import Person from './Person'

export default ({ team }) => (
  <Container>
    <Title>Our people behind the project:</Title>
    {team.map(name => <Person key={name} name={name} />)}
  </Container>
)

const Container = styled.div`
  text-align: center;
  max-width: 80%;
  margin: 0 auto 60px;

  @media only screen and (max-width: 1023px) {
    max-width: 100%;
  }
`

const Title = styled.div`
  font: ${FONT_SMALL};
  margin-bottom: 20px;
`
